import React, {useEffect, useState} from 'react'
import css from './styles.module.scss'
import LayoutDefault from '../../../layouts/default'
import { getMyCourses } from '../../../http/course'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import { stripHtml } from '../../../util/utils'
const server = process.env.REACT_APP_API_URL || null

const Course = () => {
	const [enrolls, setEnrolls] = useState(null)
	const [loading, setLoading] = useState(true)


	const fetchCourse = async () => {
    getMyCourses().then(e => {
      setEnrolls(e.rows)
      setLoading(false)
    })
	}

	useEffect(() => {
    document.title = `Meus eventos - Alissem`
    document.getElementsByTagName("META")[1].content=document.title
		fetchCourse()
	}, [])

	return (
		<LayoutDefault loading={loading}>
			{enrolls?.length > 0 ? (
				<div className={css['pg-my-courses']}>
					<Container>
						<Row>
							<Col md={4} className={css['cp-my-courses']}>
								<div className={css['cp-my-courses__content']}>
									<div className={css['cp-my-courses__content__title']}>
										<h2>Meus Eventos</h2>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
					<div className={css['cp-my-courses']}>
						<Container >
              <Row>
                {enrolls.map((enroll, index) => {
                  return (
                    <Col md={3} key={enroll.id} className={css['cp-my-course']}>
                      <div className={css['cp-my-course__content']}>
                        <div className={css['cp-my-course__content__logo']}>
                          <img src={`${server}${enroll.course.logoUrl}`} alt={enroll.course.name} />
                        </div>
                        <h3>{enroll.course.name}</h3>
                        <h4>{enroll.course.company.name}</h4>
                        <p>{stripHtml(enroll.course.informations).substring(0,60)}</p>
												<a className={`${css['cp-my-course__go']}`} href={`/curso/${enroll.course.company.permalink}/${enroll.course.id}/conteudo`} >
													Entrar
												</a>
                      </div>
                    </Col>
                  )
                })}
              </Row>
						</Container>
					</div>
				</div>				
			) : (
        <div className={css['pg-my-courses--nothing']}>
          <p>Você ainda não possui nenhum curso.</p>
        </div>
      )}
		</LayoutDefault>
	)
}

export default Course